// extracted by mini-css-extract-plugin
export default {"layout":"layout___IHsUI","columns":"columns___EiTn_","sidebar":"sidebar___Eayby","content":"content___z1VD9"};